import { FC, Fragment } from "react";

export type ImgRoundedprops = {
  src: string;
  size?: string;
};

export const ImgRounded: FC<ImgRoundedprops> = ({ src, size = "smallXs" }) => {
  return (
    <Fragment>
      <img
        alt=""
        src={src}
        className={`${
          size === "small"
            ? "h-6 w-6"
            : size === "medium"
            ? "h-8 w-8"
            : size === "large"
            ? "h-10 w-10"
            : size === "extraLarge"
            ? "h-12 w-12"
            : "h-5 w-5"
        } rounded-full`}
      />
    </Fragment>
  );
};
